import { render, staticRenderFns } from "./goldsilverin.vue?vue&type=template&id=0a8abea4&scoped=true&"
import script from "./goldsilverin.vue?vue&type=script&lang=js&"
export * from "./goldsilverin.vue?vue&type=script&lang=js&"
import style0 from "./goldsilverin.vue?vue&type=style&index=0&id=0a8abea4&scoped=true&lang=scss&"
import style1 from "./goldsilverin.vue?vue&type=style&index=1&lang=css&"
import style2 from "./goldsilverin.vue?vue&type=style&index=2&id=0a8abea4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8abea4",
  null
  
)

export default component.exports